import { render, staticRenderFns } from "./UpdateDate.vue?vue&type=template&id=a53b8ec4"
import script from "./UpdateDate.vue?vue&type=script&lang=js"
export * from "./UpdateDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports